import React, { useState } from "react";
import "./Login.css";
import logo from "../../assets/flaplogo.png";
import forgot from "../../assets/forgot.gif";
import { Link } from "react-router-dom";
import { useTitle } from "../../hooks/useTitle.js";
import axios from "axios";
import SmallLoader from "../../components/SmallLoader";
import constant from "../../constant/constant";

const Forgot = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState("");
  const [success, setSuccess] = useState("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  useTitle("Forgot Password - Reset Your Password - Flapone Aviation");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };


  const handleForgotPwd = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");
    setShowError("");
    if (email.trim() === '') {
      setShowError("Email field can't be blank.");
      setLoading(false);
    }else if(!emailRegex.test(email)){
      setLoading(false);
      setShowError("Invalid email");
    }
    else{
    axios({
      method: 'post',
      url: `${constant.base_url}/login_student.php?fun=forgotpwd`,
      headers: {},
      data: {
        forgotEmail:email,
        type:'student',
      }
      }).then(function(response) {
        if(response){
          setLoading(false);
          if(response.data.data.status === '1'){
            setSuccess(response.data.data.msg);
            setLoading(false);
            //return false;
          }else{
            setShowError(response.data.data.msg);
            setLoading(false);
            //return false;
          }
        }
      });
    }
  }

  return (
    <div className="login-container df">
      <div className="left-side flx45">
        <div className="image-container pr w100">
          <img src={forgot} alt="forgot" className="image" />
          <div className="overlay-s h-center aie fc1 pa t0 b0 l0 r0">
            <p className="overlay-text fs16 pb32 lh22 ls1 tac">
              Don't worry. Enter your email to receive a password reset link.
              Follow the instructions in the email to easily reset your
              password.
            </p>
          </div>
        </div>
      </div>
      <div className="right-side bg1 df fdc flx1">
        <div className="box-center fdc">
          <div className="box-center w100 fdc mb16">
            <img src={logo} alt="logo" className="logo" />
            <div className="head-text mt16 box-center fdc">
              <p className="fs24 fc2 ls1 mb8 ">Forgot Password</p>
              <p className="fs14 fc6">
                Don't worry. Resetting your password is!
              </p>
            </div>
          </div>
          <form className="form-area mt24 mb24">
            <label htmlFor="email" className="df fs16 ls1 fw6">
              Email<span className="fc5">*</span>
            </label>
            <input
              type="email"
              id="email"
              placeholder="Enter registered email address"
              value={email}
              onChange={handleEmailChange}
            />
            {showError && <div className="warn-msg box-center mb8 fs14 ls1 fc3 cp mt10">
             {showError}
            </div>}
            {success && <div className="warn-msg box-center mb8 fs14 ls1 fc9 cp mt10">
             {success}
            </div>}
            <button type="submit" className="h40 login-button bg3 mt10 fc1" onClick={handleForgotPwd}>
            {loading ? <SmallLoader/> :"Submit"}
            </button>
          </form>
          <div className="box-center w100 fs14 ls1 register">
            Already have an account?{" "}
            <span className="ml8 fc3 cp">
              <Link to="/login">Login Here</Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forgot;
